import TreeStore from 'stores/TreeStore';
import GngNode from 'models/GngNode';

const NAMESPACE = 'gng';

export default class GngTreeStore extends TreeStore {

  nodes = this.collection({
    model: GngNode
  })

  foundNodes = this.collection({
    model: GngNode
  })

  async fetchChildNodes(parentNode) {
    return await super.fetchChildNodes(parentNode, NAMESPACE);
  }

  async fetchParents(parentNode) {
    return await super.fetchParents(parentNode, NAMESPACE);
  }

  async search(term) {
    return await super.search(term, NAMESPACE);
  }

  toString() {
    return NAMESPACE;
  }

}



// WEBPACK FOOTER //
// ./src/stores/GngTreeStore.js